import union from 'lodash/union';
import forOwn from 'lodash/forOwn';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import FlowerQuestions from '@/content/faqs/answers/flower.json';
import AccountQuestions from '@/content/faqs/answers/account.json';
import GeneralQuestions from '@/content/faqs/answers/general.json';
import GiftingQuestions from '@/content/faqs/answers/gifting.json';
import DeliveryQuestions from '@/content/faqs/answers/delivery.json';
import FreeFlowerQuestions from '@/content/faqs/answers/freeFlower.json';
import ShopQuestions from '@/content/faqs/answers/shop.json';

export default class FaqAnswers {
    questionsByCategory = {}

    allQuestions = []

    constructor() {
        this.questionsByCategory = {
            '/faq/general': GeneralQuestions.items,
            '/faq/account': AccountQuestions.items,
            '/faq/flower': FlowerQuestions.items,
            '/faq/gifting': GiftingQuestions.items,
            '/faq/delivery': DeliveryQuestions.items,
            '/faq/free-flower': FreeFlowerQuestions.items,
            '/faq/shop': ShopQuestions.items,
        };

        forOwn(this.questionsByCategory, (faqArray) => (this.allQuestions = union(this.allQuestions, faqArray)));
    }

    handle() {
        forEach(this.allQuestions, (question, key) => {
            let answer = '';

            if (isArray(question.answer)) {
                answer = question.answer.join('</p><p>');
            } else {
                answer = question.answer;
            }

            this.allQuestions[key].answer = `<p>${answer}</p>`;
        });

        return new Promise((resolve) => resolve(this.allQuestions));
    }

    findAnswersByPath(path) {
        path = path.replace(/(\/faq\/[^/]+).*/, '$1');

        return new Promise((resolve) => resolve(this.questionsByCategory[path]));
    }
}
